var parent = require('../../es/instance/splice');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/instance/splice.js
// module id = 1120
// module chunks = 0